import * as utils from '@intrasync/utils';
import DialogActions from '@mui/material/DialogActions';

import { Button } from '../Button';
import Spacer from '../Spacer/Spacer';
import injectStores from 'components/RootStore/injectStores';
import RootStore from 'stores/RootStore';
import { RouterStore } from 'stores/RouterStore';
import { computed } from 'mobx';

interface DialogFooterProps {
  children?: React.ReactNode;
  rootStore?: RootStore;
  routerStore?: RouterStore;
}

const DialogFooter = injectStores(
  ({ children, rootStore, routerStore }: DialogFooterProps) => {
    if (!routerStore || !rootStore) return null;
    const { renderDialog, dialogCloseFunction } = routerStore;
    if (!renderDialog) return null;
    console.log('renderDialog', renderDialog);

    const { submitButtonText, onSubmitValidation } = renderDialog;

    const disabled = computed(
      () => onSubmitValidation && !onSubmitValidation({ rootStore })
    ).get();

    console.log('disabled', disabled);

    return (
      <DialogActions id={utils.uuid()}>
        {renderDialog?.cancelButton && (
          <>
            <Button color="primary" onClick={() => routerStore.closeDialog()}>
              Cancel
            </Button>
            <Spacer />
          </>
        )}
        {children && children}
        {renderDialog && renderDialog.onSubmit && (
          <Button
            disabled={disabled}
            color="primary"
            onClick={async () => {
              if (renderDialog?.onSubmit) {
                await renderDialog.onSubmit({ rootStore });
              }
              dialogCloseFunction();
            }}
          >
            {submitButtonText || 'Submit'}
          </Button>
        )}
      </DialogActions>
    );
  }
);

export default DialogFooter;
